module.exports = __webpack_public_path__ + "static/media/logo_home.38fd8c07.png";